import { render, staticRenderFns } from "./TfaModal.vue?vue&type=template&id=a45de1f8&lang=html&"
import script from "./TfaModal.vue?vue&type=script&lang=js&"
export * from "./TfaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TfaModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a45de1f8')) {
      api.createRecord('a45de1f8', component.options)
    } else {
      api.reload('a45de1f8', component.options)
    }
    module.hot.accept("./TfaModal.vue?vue&type=template&id=a45de1f8&lang=html&", function () {
      api.rerender('a45de1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/tfa/TfaModal.vue"
export default component.exports